import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

function SEFArrivalDeparture({ Attendee }) {
  return (
    <>
      <div className="progress-box">
        <div className="progress-container">
          <div className="progress-item">
            <div className="progress-item-content">
              <span className="progress-text">
                <strong style={{ fontSize: "max(0.8vw, 12px)" }}>
                  Arrival and Departure
                </strong>
              </span>
            </div>
            <div className="progress-bar">
              <div
                className={`progress-bar-fill ${
                  Attendee.SummerArrivalDeparture?.Progress
                    ? //
                      Attendee.SummerArrivalDeparture?.Progress === "Complete"
                      ? "Complete"
                      : Attendee.SummerArrivalDeparture?.Progress ===
                        "In_Progress"
                      ? "In_Progress"
                      : Attendee.SummerArrivalDeparture?.Progress ===
                        "Awaiting_Review"
                      ? "Awaiting_Review"
                      : "Incomplete"
                    : //
                      "Incomplete"
                }`}
              >
                <span
                  className={`progress-bar-text ${
                    Attendee.SummerArrivalDeparture?.Progress
                      ? //
                        Attendee.SummerArrivalDeparture?.Progress === "Complete"
                        ? "Complete"
                        : Attendee.SummerArrivalDeparture?.Progress ===
                          "In_Progress"
                        ? "In_Progress"
                        : Attendee.SummerArrivalDeparture?.Progress ===
                          "Awaiting_Review"
                        ? "Awaiting_Review"
                        : "Incomplete"
                      : //
                        "Incomplete"
                  }`}
                  style={{ fontSize: "max(0.8vw, 12px)" }}
                >
                  {Attendee && Attendee._id && Attendee._id.length > 0
                    ? Attendee.SummerArrivalDeparture?.Progress
                      ? Attendee.SummerArrivalDeparture?.Progress === "Complete"
                        ? "Complete"
                        : Attendee.SummerArrivalDeparture?.Progress ===
                          "In_Progress"
                        ? "In Progress"
                        : Attendee.SummerArrivalDeparture?.Progress ===
                          "Incomplete"
                        ? "Incomplete"
                        : Attendee.SummerArrivalDeparture?.Progress ===
                          "Awaiting_Review"
                        ? "Awaiting Review"
                        : "Incomplete"
                      : //
                        "Incomplete"
                    : //
                      "Loading..."}
                </span>
              </div>
            </div>
            <Link
              to={`/Student/ArrivalDeparture/${
                Attendee._id && Attendee._id.length > 0 ? Attendee._id : ""
              }`}
              style={{
                textDecoration: "none",
                color: "inherit",
                width: "20%",
                marginRight: "10px",
              }}
              target="_blank"
            >
              <button
                className={`go-to-button ${
                  Attendee && Attendee._id && Attendee._id.length > 0
                    ? Attendee.SummerArrivalDeparture?.Progress
                      ? Attendee.SummerArrivalDeparture?.Progress === "Complete"
                        ? "Complete"
                        : Attendee.SummerArrivalDeparture?.Progress ===
                          "In Progress"
                        ? "In Progress"
                        : Attendee.SummerArrivalDeparture?.Progress ===
                          "Incomplete"
                        ? "Incomplete"
                        : Attendee.SummerArrivalDeparture?.Progress ===
                          "Awaiting Review"
                        ? "Awaiting Review"
                        : "Incomplete"
                      : //
                        "Incomplete"
                    : //
                      "Loading..."
                }`}
              >
                View Page
              </button>
            </Link>
          </div>
        </div>
      </div>
    </>
  );
}

export default SEFArrivalDeparture;
